export default () => item => {
    let name = item.name;
    switch (item.type) {
        case 'SerializedDate':
            name += '.Milliseconds';
            break;
        default:
            break;
    }
    return name;
}